var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ml-3 dr-designer-component-card dr-dc-container-component-designer dr-dc-card"},[_c('font-awesome-icon',{attrs:{"icon":['fal', _vm.component.icon],"size":"1x"}}),_c('div',{staticClass:"dr-dc-card-title"},[_vm._v(_vm._s(_vm.component.name))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }